// Export error copy, kept out of api.ts so components whose tests mock
// "../api" wholesale still get the real helper.

export const TRIAL_EXPORT_LOCKED_MESSAGE =
  "CSV export unlocks once your free trial converts to a paid subscription. Everything else in your plan works during the trial.";

export class TrialExportLockedError extends Error {
  constructor() {
    super(TRIAL_EXPORT_LOCKED_MESSAGE);
    this.name = "TrialExportLockedError";
  }
}

/** The copy to show for a failed export: the trial lock, else `fallback`. */
export function exportErrorMessage(err: unknown, fallback: string): string {
  return err instanceof TrialExportLockedError ? err.message : fallback;
}
